"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M21 3H3v18h18zm-4 10h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddBoxSharp');